import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatters';

export const CurrencyValue = ({ value = 0, signed = false, className = '' }) => {
  const { i18n } = useTranslation();
  const numericValue = Number(value || 0);
  const formatted = formatCurrency(Math.abs(numericValue), i18n.language);
  const prefix = signed && numericValue < 0 ? '-' : '';

  return (
    <span className={`tabular-nums ${className}`}>
      {prefix}
      {formatted}
    </span>
  );
};
